import { Crown, Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

const NAV_LINKS = [
  { path: '/', label: 'Home', testId: 'nav-home' },
  { path: '/products', label: 'Products', testId: 'nav-products' },
  { path: '/about', label: 'About', testId: 'nav-about' },
  { path: '/faq', label: 'FAQ', testId: 'nav-faq' },
  { path: '/blog', label: 'Blog', testId: 'nav-blog' },
  { path: '/contact', label: 'Contact', testId: 'nav-contact' },
];

export const Navigation = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F6F0]/80 border-b border-[#EADCCC]" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link" onClick={() => setMobileOpen(false)}>
            <Crown className="w-8 h-8 text-[#A85A43] group-hover:text-[#8C4935] transition-colors" strokeWidth={1.5} />
            <span className="text-2xl font-[Playfair_Display] italic text-[#2A2626] tracking-tight">
              Protect Your Crown
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-[Manrope] transition-colors ${
                  isActive(link.path) ? 'text-[#A85A43] font-semibold' : 'text-[#5C5855] hover:text-[#A85A43]'
                }`}
                data-testid={link.testId}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Hamburger Button */}
          <button
            className="md:hidden p-2 text-[#2A2626] hover:text-[#A85A43] transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            data-testid="mobile-menu-button"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-96 border-t border-[#EADCCC]' : 'max-h-0'
        }`}
        data-testid="mobile-menu"
      >
        <div className="px-6 py-4 bg-[#F9F6F0]/95 backdrop-blur-xl space-y-1">
          {NAV_LINKS.map(link => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMobileOpen(false)}
              className={`block py-3 px-4 rounded-lg text-base font-[Manrope] transition-colors ${
                isActive(link.path)
                  ? 'text-[#A85A43] font-semibold bg-[#A85A43]/10'
                  : 'text-[#5C5855] hover:text-[#A85A43] hover:bg-[#A85A43]/5'
              }`}
              data-testid={`mobile-${link.testId}`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};
